<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.625 1H13.375V6.625H6.625V1Z" stroke="currentColor"
            stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.25 13.3748H19V18.9998H12.25V13.3748Z" stroke="currentColor"
            stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 13.3748H7.75V18.9998H1V13.3748Z" stroke="currentColor"
            stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.37305 13.375V10H15.623V13.375" stroke="currentColor" stroke-width="1.125" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M10 10V6.625" stroke="currentColor" stroke-width="1.125" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
